import { Col, Typography, Layout, Space, Button, Popconfirm } from "antd";
import { PlusOutlined, ReloadOutlined, DeleteOutlined } from "@ant-design/icons";
import Header160 from "../../header/header";

const { Title, Text } = Typography;

export default function EntregasHeader({ onCreate, onRefresh, onDeleteSelected, permissionInsert, permissionDelete, loading, selectedRows }) {

  return (
    <div className="container" style={{ paddingBottom: 20 }}>
      <Layout className="container">
        <div className="header-filter-container d-flex align-items-center justify-content-between">
          <Header160 />
          <Col flex="auto" style={{ textAlign: "center" }}>
            <Space direction="vertical" size={0} align="center">
              <Title
                level={3}
                style={{
                  margin: 0,
                  color: "#042956",
                  fontWeight: 600
                }}
              >
                Gestión de Entregas
              </Title>
              <Text
                style={{
                  color: "#6b7280",
                  fontSize: 14
                }}
              >
                Registro y control de entregas a participantes u organizaciones
              </Text>
              <Space style={{ marginTop: 10 }}>
                {permissionInsert && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={onCreate}
                  >
                    Nueva entrega
                  </Button>
                )}
                {permissionDelete && (
                  <Popconfirm
                    title="Eliminar registros"
                    description="¿Estás seguro de eliminar los registros seleccionados?"
                    okText="Sí, eliminar"
                    cancelText="Cancelar"
                    okButtonProps={{ danger: true }}
                    onConfirm={onDeleteSelected}
                    disabled={!selectedRows?.length}
                  >
                    <Button
                      danger
                      icon={<DeleteOutlined />}
                      disabled={!selectedRows?.length}
                    >
                      Eliminar seleccionados
                    </Button>
                  </Popconfirm>
                )}
              </Space>
              <Space style={{ marginTop: 10 }}>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={onRefresh}
                  loading={loading}
                >
                  Refrescar
                </Button>
              </Space>
            </Space>
          </Col>
        </div>
      </Layout>
    </div>
  );
}